export default __webpack_public_path__ + "static/media/hardship.dc463425.svg";